import { makeModuleStateSelector } from "@client/content/selectors";
import { globals } from "@client/globals";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type OrderConfirmation } from "./types";

export const localStateSelector = makeModuleStateSelector<OrderConfirmation.State>(defaultState, previewState);

export const apiUrlSelector = createSelector([], () => globals.paths.apiUrl);
